import FloatingLabelInput from './FloatingLabelInput';

export { FloatingLabelInput };
